import { render, staticRenderFns } from "./AddFunds.vue?vue&type=template&id=2d5eb864&scoped=true&"
import script from "./AddFunds.vue?vue&type=script&lang=js&"
export * from "./AddFunds.vue?vue&type=script&lang=js&"
import style0 from "./AddFunds.vue?vue&type=style&index=0&id=2d5eb864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5eb864",
  null
  
)

export default component.exports